export default __webpack_public_path__ + "static/clientWork4-26823158be46774a0a8a7fdbe962b9b7.png";